import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

const TICKET_SCROLL_OFFSET = 120;
const getTicketScrollTop = (element) => Math.max(element.offsetTop - TICKET_SCROLL_OFFSET, 0);

window.onload = () => {
	if (window.location.href.endsWith('/tickets/')) {
	  const orderTicketsContainer = document.querySelector('#orderTicketsContainer');
	  if (orderTicketsContainer) {
		 orderTicketsContainer.classList.remove('hide');
		 window.dispatchEvent(new CustomEvent('tickets:show', { detail: { containerId: orderTicketsContainer.id } }));
		 window.scrollTo({ top: getTicketScrollTop(orderTicketsContainer), behavior: 'smooth' });
	  }
	}
 };


export default class ButtonRegister {
  constructor(element) {
    this.element = element;
    this.init();
	 this.addEventListeners();
  }

  init() {
    // pages with multiple ticket buttons ("Andere dagen en tijden" rows) don't get a sticky button
    if (document.querySelector('a.course-detail__lestijd-btn')) {
      return;
    }
    ScrollTrigger.create({
      trigger: this.element,
      start: 'top top',

      onEnter: () => {
        this.element.classList.add('is-sticky');
		  document.querySelector('.nav-logo').classList.add('is-sticky');
      },

      onLeaveBack: () => {
        this.element.classList.remove('is-sticky');
		  document.querySelector('.nav-logo').classList.remove('is-sticky');
      }
    });
  }
	addEventListeners() {
		this.element.addEventListener('click', (event) => {
			event.preventDefault();
			document.querySelectorAll('#orderTicketsContainer').forEach((el) => {
				el.classList.remove('hide');
				window.dispatchEvent(new CustomEvent('tickets:show', { detail: { containerId: el.id } }));
				scrollTo({ top: getTicketScrollTop(el), behavior: 'smooth' });
			});
		});
	}
}
